import Paper, { PaperProps } from '@material-ui/core/Paper';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Colors } from '@rentguru/commons-utils';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    borderRadius: 12,
    textAlign: 'center',
    marginBottom: 30,
    overflowX: 'auto',
    boxShadow: 'none',
    outline: `1px solid ${Colors.PORCELAIN_GREY_3}`,
  },
  padding: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

interface ElevatedPaperProps extends PaperProps {
  removePadding?: boolean;
}

export const ElevatedPaper = ({ className, removePadding, children, style, ...rest }: ElevatedPaperProps) => {
  const classes = useStyles();

  return (
    <Paper
      className={clsx(classes.paper, removePadding ?? classes.padding, className)}
      style={style || {}}
      elevation={10}
      {...rest}
    >
      {children}
    </Paper>
  );
};
